export const endpoints = {
  optionsCollection: (codetableId: number) => `optionsCollection/${codetableId}/search`,
  optionsCollectionAll: (codetableId: number) => `code/optionsCollection/${codetableId}/all/options`,
  deleteCodeItem: (codetableId: number, codeId: number) => `optionsCollection/${codetableId}/code/${codeId}`,
  optionPath: (codetableId: number, codeId: number) => `optionsCollection/${codetableId}/code/${codeId}/path`,
  codesAccess: (codetableId: number) => `optionsCollection/${codetableId}/code/access`,
  deleteRows: (codetableId: number) => `optionsCollection/${codetableId}/search`,
  codetablesAccess: 'optionsCollection/access',
  duplicateRows: 'optionsCollection/indicatorFactors:duplicate',
  saveFactors: 'optionsCollection/indicatorFactor/factor',
  saveComments: 'optionsCollection/indicatorFactor/comments'
};
